// src/components/widgets/Loader/Loader.tsx
import React, { useEffect } from 'react';
import './Loader.scss';

interface LoaderProps {
    text?: string;
    fullScreen?: boolean;
    blockScroll?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
                                           text,
                                           fullScreen = true,
                                           blockScroll = true
                                       }) => {
    // Блокируем скролл при монтировании
    useEffect(() => {
        if (blockScroll) {
            document.body.style.overflow = 'hidden';
        }

        // Возвращаем скролл при размонтировании
        return () => {
            if (blockScroll) {
                document.body.style.overflow = 'unset';
            }
        };
    }, [blockScroll]);

    return (
        <div className={`loader-container ${fullScreen ? 'full-screen' : ''}`}>
            <div className="loader-content">
                <div className="loader-spinner"></div>
            </div>
        </div>
    );
};

export default Loader;